var map = {
	"./NAWI_Graz_Logo_2015.png": 473,
	"./NAWI_Graz_Logo_2015.webp": 817,
	"./background_landingpage.jpg": 495,
	"./cropped_personal_image.jpg": 812,
	"./gene-7031244_640.png": 544,
	"./georg-herbert-bluthner.webp": 566,
	"./observatory.jpg": 204,
	"./people_study.jpg": 917,
	"./the-growing-inaccessibility-of-science-v0-gusdztk7vf3d1.webp": 945,
	"./university-library-4825366_640.jpg": 118,
	"./university-library-4825366_640.webp": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;